import { Flex, Text } from 'rebass/styled-components';
import { Input } from '../../../../components/TextInput';
import { IBuilderCtrlViewProps } from '../types';

export const CheckBoxesCtrl: React.FC<IBuilderCtrlViewProps> = ({ properties }) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => {}} fontWeight={500}>
          {`${(properties || {}).question || 'Question'}${((properties || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {(properties || {}).description || ''}
        </Text>
      </Flex>
      <Flex flex={1} justifyContent={'flex-start'} flexDirection={'column'}>
        {(((properties || {}).ctrlProps || {}).options || []).map((x) => {
          return (
            <Flex mb={2}>
              <Input type="checkbox" checked={x.isChecked} id={x.value} name={x.value} />
              <label htmlFor={x.value} style={{ marginLeft: '16px' }}>
                {x.label}
              </label>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};
